import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import LogInModal from 'flarum/forum/components/LogInModal';
import { icon } from './ui';
const primary = [{
  label: 'Wszystkie dyskusje',
  href: '/',
  icon: 'far fa-comments',
  hint: 'Najnowsza aktywność całej społeczności'
}, {
  label: 'Obserwowane',
  href: '/following',
  icon: 'fas fa-star',
  hint: 'Tematy i dyskusje, które obserwujesz'
}, {
  label: 'Wiadomości',
  href: '/messages',
  icon: 'far fa-envelope',
  hint: 'Prywatne rozmowy na forum'
}, {
  label: 'Tagi i działy',
  href: '/tags',
  icon: 'fas fa-th-large',
  hint: 'Pełny katalog kategorii forum'
}];
const community = [{
  label: 'Ogłoszenia',
  href: '/t/ogloszenia',
  icon: 'fas fa-bullhorn',
  hint: 'Oficjalne komunikaty administracji'
}, {
  label: 'Aktualizacje',
  href: '/t/aktualizacje',
  icon: 'fas fa-star',
  hint: 'Zmiany na serwerze i forum'
}, {
  label: 'Pomoc techniczna',
  href: '/t/pomoc-techniczna',
  icon: 'fas fa-wrench',
  hint: 'Problemy z grą, kontem i forum'
}, {
  label: 'Rozgrywka',
  href: '/t/rozgrywka',
  icon: 'fas fa-gamepad',
  hint: 'Dyskusje związane z grą'
}, {
  label: 'Frakcje i organizacje',
  href: '/t/frakcje-i-organizacje',
  icon: 'fas fa-users',
  hint: 'Służby, organizacje i rekrutacje'
}, {
  label: 'Giełda',
  href: '/t/gielda',
  icon: 'fas fa-tag',
  hint: 'Pojazdy, nieruchomości i usługi'
}];
const services = [{
  label: 'Serwer',
  href: '/serwer',
  icon: 'fas fa-server',
  hint: 'Status i informacje o serwerze'
}, {
  label: 'Ranking',
  href: '/ranking',
  icon: 'fas fa-trophy',
  hint: 'Rankingi graczy'
}, {
  label: 'NovaID',
  href: '/novaid',
  icon: 'fas fa-id-card',
  hint: 'Twoje wspólne konto NovaTruck'
}, {
  label: 'Premium',
  href: '/premium',
  icon: 'fas fa-gem',
  hint: 'Pakiety i korzyści Premium'
}, {
  label: 'Sąd',
  href: '/sad',
  icon: 'fas fa-balance-scale',
  hint: 'Nova Justice — prywatne sprawy'
}];
export default class NovaQuickNavigation extends Component {
  open = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.open = false;
  }
  oncreate() {
    document.addEventListener('keydown', this.onKeyDown);
  }
  onremove() {
    document.removeEventListener('keydown', this.onKeyDown);
    document.body.classList.remove('NtQuickNav-open');
  }
  onKeyDown = event => {
    if (event.key === 'Escape' && this.open) this.setOpen(false);
  };
  setOpen(value) {
    this.open = value;
    document.body.classList.toggle('NtQuickNav-open', value);
    m.redraw();
  }
  startDiscussion(event) {
    event.preventDefault();
    if (!app.session.user) {
      app.modal.show(LogInModal, {});
      return;
    }
    this.setOpen(false);
    app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
      user: app.session.user
    }).then(() => app.composer.show()).catch(error => {
      console.error('[NovaTruck] Nie udało się otworzyć kreatora dyskusji:', error);
      app.alerts.show({
        type: 'error'
      }, 'Nie udało się otworzyć kreatora dyskusji. Odśwież stronę i spróbuj ponownie.');
    });
  }
  link(item) {
    const path = String(m.route.get() || '/').split('?')[0].replace(/\/$/, '') || '/';
    const active = path === item.href || item.href !== '/' && path.startsWith(`${item.href}/`);
    return m(Link, {
      href: item.href,
      className: active ? 'is-active' : '',
      onclick: () => this.setOpen(false)
    }, m("span", null, icon(item.icon)), m("span", null, m("strong", null, item.label), m("small", null, item.hint)), icon('fas fa-chevron-right'));
  }
  view() {
    return m('[', null, m("button", {
      type: "button",
      className: `NtQuickNav-toggle ${this.open ? 'is-open' : ''}`,
      "aria-label": "Otw\xF3rz Nova Quick Navigation",
      "aria-expanded": this.open ? 'true' : 'false',
      onclick: () => this.setOpen(!this.open)
    }, icon(this.open ? 'fas fa-times' : 'fas fa-bars'), m("span", null, "MENU")), m("button", {
      type: "button",
      className: `NtQuickNav-backdrop ${this.open ? 'is-open' : ''}`,
      "aria-label": "Zamknij menu",
      onclick: () => this.setOpen(false)
    }), m("aside", {
      className: `NtQuickNav ${this.open ? 'is-open' : ''}`,
      "aria-hidden": this.open ? 'false' : 'true'
    }, m("header", null, m("small", null, "NOVA QUICK NAVIGATION"), m("strong", null, "Szybka nawigacja"), m("p", null, "Forum, spo\u0142eczno\u015B\u0107 i najwa\u017Cniejsze us\u0142ugi NovaTruck w jednym miejscu.")), m("button", {
      type: "button",
      className: "Button Button--primary NtQuickNav-new",
      onclick: event => this.startDiscussion(event)
    }, icon('fas fa-pen'), " ", m("span", null, "Rozpocznij dyskusj\u0119")), m("section", null, m("h3", null, "Forum"), m("nav", null, primary.map(item => this.link(item)))), m("section", null, m("h3", null, "Spo\u0142eczno\u015B\u0107"), m("nav", null, community.map(item => this.link(item)))), m("section", null, m("h3", null, "NovaTruck"), m("nav", null, services.map(item => this.link(item))))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/NovaQuickNavigation', NovaQuickNavigation);